// packages import
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Tooltip, Typography } from "@mui/material";
import { FC, } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
// component import
import { EmptyData } from "../../common/EmptyData";
import { ActiveCaseListingSkeleton } from "../../skeletons/ActiveCaseListingSkeleton";
// others
import { ExternalUserRoleRole } from "../../../../generated";
import { ActiveCaseListingDashboardProps } from "../../../interfaceTypes";
import { flexCenter, taskListStyle } from "../../../theme/styleConstants";

export const ActiveCasesListing: FC<ActiveCaseListingDashboardProps> = ({ setCurrentPage, filterActiveACases, loading }) => {
  const isEmpty = filterActiveACases?.length === 0 && !loading
  const fetchMoreData = () => setCurrentPage((prevP) => prevP + 1)

  return (
    <Box height='336px' paddingX={1} id="activeCasesFetch" sx={{ overflowX: 'auto' }} marginTop='20px'>
      {loading &&
        <Box mt='28px'>
          <ActiveCaseListingSkeleton noOfRows={4} />
        </Box>
      }

      {isEmpty &&
        <Box height='319px' sx={flexCenter}>
          <EmptyData title='No Active Cases' height="624px" iconSize="100px" fontSize="20px" />
        </Box>
      }

      <InfiniteScroll
        dataLength={filterActiveACases?.length!}
        next={fetchMoreData}
        hasMore
        loader={loading}
        scrollableTarget="activeCasesFetch"
      >
        <List>
          {filterActiveACases?.map((item) => {
            const { id, caseNumber, caseToExternalUserToExternalUserRole, title } = item || {}
            const clientDetail = caseToExternalUserToExternalUserRole?.find((item) => item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles && item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles[0]?.externalUserRole?.role === ExternalUserRoleRole.Client)?.externalUserToExternalUserRole.externalUser
            const { firstName, lastName, clientNumber } = clientDetail || {}
            const fullName = `${firstName || ''} ${lastName || ''}`.trim()
            const clientLabel = [clientNumber ? `#${clientNumber}` : null, fullName || null].filter(Boolean).join(' – ') || '—'

            return (
              <ListItem
                sx={taskListStyle}
                key={`${id}-${title}`}
                secondaryAction={
                  <IconButton component={Link} to={`/matters/matter-detail/${id}`}>
                    <VisibilityIcon color='primary' />
                  </IconButton>
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    <InsertDriveFileIcon />
                  </Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={
                    <Tooltip title={title || ''} placement="bottom-start" arrow>
                      <Box component="span" sx={{ pr: 6, maxWidth: '100%', flexWrap: 'wrap', display: 'block' }}>
                        <Typography component="span" variant="body1">
                          #{caseNumber}
                          {title ? ` – ${title}` : ''}
                        </Typography>
                      </Box>
                    </Tooltip>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: 'block', mt: 0.25, fontSize: '0.7rem', pr: 6 }}
                    >
                      {clientLabel}
                    </Typography>
                  }
                  sx={{ '& .MuiListItemText-secondary': { mt: 0.25 }, paddingRight: 6 }}
                />
              </ListItem>
            )
          })}
        </List>
      </InfiniteScroll>
    </Box>
  )
}